/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700,800&display=swap);.spinner[_ngcontent-%COMP%]{padding:60px;font-size:.9rem;color:#626970;text-align:center}.overFlow[_ngcontent-%COMP%]{max-height:300px;overflow-y:auto}"];
export { styles as styles };
